export interface EditVendorModal {
  companyUserId: number;
  username: string;
  email: string;
  isActive: boolean;
  role: string;
  newPassword: string;
  vendorName: string;
  vendorNumber: string;
  isNewUser: boolean;
}

export const defaultEditVendorModal: EditVendorModal = {
  companyUserId: 0,
  username: '',
  email: '',
  isActive: true,
  role: '',
  newPassword: '',
  vendorName: '',
  vendorNumber: '',
  isNewUser: false,
};
